import WeeklyChallengeBase from "./WeeklyChallengeBase";

export default function WeeklySubjectChallenge() {
  return (
    <WeeklyChallengeBase
      examType="SUBJECT_PRACTICE"
      title="📘 Weekly Subject Practice Challenge"
      subtitle="Compete using subject practice exams • Rankings reset every week"
    />
  );
}
